import { motion } from "framer-motion";
import { MapPin, MessageCircle, Languages, BadgeIndianRupee, ShieldCheck } from "lucide-react";
import SectionHead from "./SectionHead";
import { IMAGES } from "@/lib/site";

const REASONS = [
  { icon: MapPin, title: "Deep Rayagada roots", desc: "Local drivers who know every ghat road, shortcut and sunrise point in southern Odisha." },
  { icon: MessageCircle, title: "Instant WhatsApp confirmation", desc: "No forms, no waiting. Your booking is confirmed in a chat, in minutes." },
  { icon: Languages, title: "Polyglot drivers", desc: "Odia, Hindi, English and Telugu-speaking chauffeurs for every kind of traveller." },
  { icon: BadgeIndianRupee, title: "Transparent pricing", desc: "Clear per-kilometre rates with zero hidden fees — the quote is the price." },
  { icon: ShieldCheck, title: "Sanitised & GPS-tracked", desc: "Every vehicle is cleaned before each trip and tracked throughout your journey." },
];

export default function WhyUs() {
  return (
    <section data-testid="why-choose-us-section" className="mx-auto max-w-7xl px-4 py-24 sm:px-8 lg:px-16">
      <div className="grid items-start gap-12 lg:grid-cols-2">
        <div>
          <SectionHead
            overline="Why Jay Jagannath"
            title="A travel partner, not just a taxi"
            sub="Families, pilgrims and companies across Odisha trust us with the journeys that matter most."
          />
          <div className="mt-10 space-y-6">
            {REASONS.map((r, i) => (
              <motion.div
                key={r.title}
                initial={{ opacity: 0, x: -24 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
                className="flex gap-4"
              >
                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-[#D4AF37]/30 bg-[#171F26]">
                  <r.icon className="h-5 w-5 text-[#D4AF37]" strokeWidth={1.5} />
                </div>
                <div>
                  <h3 className="font-serif text-lg font-semibold">{r.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-white/60">{r.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="relative lg:sticky lg:top-28"
        >
          <div className="overflow-hidden rounded-3xl border border-[#D4AF37]/20">
            <img src={IMAGES.deities} alt="The revered deities of the Jagannath tradition" className="h-[540px] w-full object-cover" loading="lazy" />
          </div>
          <div className="absolute -bottom-6 -left-4 rounded-2xl border border-[#D4AF37]/30 bg-[#0F1418] px-6 py-4 shadow-2xl sm:-left-8">
            <p className="font-serif text-2xl font-semibold text-[#D4AF37]">ଜୟ ଜଗନ୍ନାଥ</p>
            <p className="mt-1 text-xs uppercase tracking-widest text-white/50">In every journey we carry</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
